import * as Yup from 'yup';

export const isNumeric = (value: string): boolean => {
    return /^\d*$/.test(value);
};

export const ApplicationIDValidationSchema = Yup.object().shape({
    idInput: Yup.string().required('ID is required.'),
});
